var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components-layout nhylfwtx pd0"},[_c('div',{staticClass:"picture"},[_c('img',{attrs:{"src":_vm.picture}})]),_c('div',{staticClass:"pdf"},[_c('Pdf',{attrs:{"url":_vm.url}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }